import { Component, Injector } from '@angular/core';
import {
    NavigationCancel,
    NavigationEnd,
    NavigationError,
    NavigationStart,
    Router,
    RouterEvent
} from '@angular/router';
import { AuthenticationService } from './core/services/authentication/authentication.service';
import { LoadingService } from './services/loading-service/loading.service';
import { RealTimeDataService } from './services/rt-data/rt-data.service';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css', './primeng.styles.overrides.css'],
    providers: [],
})
export class AppComponent {
    /**
     * Allows for retrieving singletons using `AppComponent.injector.get(MyService<)`
     * This is good to prevent injecting the service as constructor parameter.
     */
    static injector: Injector;
    msgs: Notification[] = [];
    ongoingRequests = 0;
    showMenu: boolean;
    showHeader: boolean;
    public switchingRoutes: boolean;

    constructor(
        injector: Injector,
        private router: Router,
        private loadingService: LoadingService,
        private auth: AuthenticationService,
        private rtDataService: RealTimeDataService,
        public translate: TranslateService,
        private config: PrimeNGConfig,
    ) {
        AppComponent.injector = injector;

        let browserLanguage = navigator.language.substring(0, 2);

        this.translate.addLangs(['en-US', 'es-ES', 'ca-ES', 'it-IT']);

        /* If there's no user language set in Local Storage, use the browser's language */
        if (!localStorage.getItem('lang')) {
            switch (browserLanguage) {
                case 'es':
                    this.translate.setDefaultLang('es-ES');
                    break;
                case 'ca':
                    this.translate.setDefaultLang('ca-ES');
                    break;
                case 'it':
                    this.translate.setDefaultLang('it-IT');
                    break;
                default:
                    this.translate.setDefaultLang('en-US');
                    break;
            }
        } else {
            this.translate.use(localStorage.getItem('lang'));
        }

        //for login page hidde menu bar
        this.router.events.subscribe((r: any) => {
            if (r.constructor.name !== 'NavigationEnd') {
                return;
            }

            //Hidde menu bar on home
            this.showMenu =
                r.url !== '/' &&
                r.url !== '/logout' &&
                r.url !== '/login' &&
                r.url !== '/map' &&
                r.url !== '/printMapa' &&
                r.url !== '/rt' &&
                r.url !== '/reports' &&
                r.url !== '/COEXPanel' &&
                r.url !== '/sat' &&
                r.url !== '/satMap' &&
                r.url !== '/logistics' &&
                r.url !== '/administration' &&
                r.url !== '/rent'
                r.url !== '/reports-dashboard' 
                ;
            //let m = this.router.url.match('.*?map=(.*)');
            let m = this.router.url.match('/map/rt-map');

            if (m && auth.user != null) {
                this.rtDataService.initDetachedMode();
            }

            /*if (m) {
                this.showMenu = false;
                alert("m not null");
                this.auth.loginWithToken(decodeURIComponent(m[1])).then(() => {
                    this.rtDataService.initDetachedMode(); 
                    //this.router.navigate(['map']);
                    this.router.navigate(['/map/sat-map']);

                });
            }
            */

            /**
             * When the user logs in the app. If the cookie app-lang is not set or its value is different to the
             * user language. The app sets the apropriate value and forces the app to reload (checkLanguage() in authentication.service)
             * This reload, directs the user to the rout /login={token} whith a valid login token.
             *
             */
            m = this.router.url.match('.*?login=(.*)');
            if (m) {
                this.showMenu = false;
                this.auth.loginWithToken(decodeURIComponent(m[1])).then(() => {
                    let defaultDashboard = this.auth.user.defaultDashboard;
                    if (!defaultDashboard && this.auth.user.canSeeUTERondesDashboard) {
                        defaultDashboard = defaultDashboard = 'COEXPanel';
                    }
                    if (!defaultDashboard && this.auth.user.canSeeRTDashboard) {
                        defaultDashboard = defaultDashboard = 'rt';
                    }
                    this.router.navigate([defaultDashboard]);
                });
            }
        });

        this.loadingService.requestCounterSubject.subscribe((coun) => {
            this.ongoingRequests = coun;
        });
    }

    ngOnInit() {
        this.router.events.subscribe((route: any) => this.navigationInterceptor(route));
    }

    /**
     * navigationInterceptor
     * Used to activate the loading spinner when the router is transitioning between routes.
     * */
    private navigationInterceptor(event: RouterEvent): void {

        if (event instanceof NavigationStart) {
            this.switchingRoutes = true;
        }
        if (event instanceof NavigationEnd) {
            this.switchingRoutes = false;
        }
        if (event instanceof NavigationCancel) {
            this.switchingRoutes = false;
        }
        if (event instanceof NavigationError) {
            this.switchingRoutes = false;
        }

        this.config.setTranslation({
            firstDayOfWeek: this.translate.instant('date.firstDayOfWeek'),
            dayNamesMin: this.translate.instant('date.dayNamesMin'),
            monthNames: this.translate.instant('date.months'),
            monthNamesShort: this.translate.instant('date.monthNamesShort'),
        });
    }

}
